module.exports = __webpack_public_path__ + "static/media/CompLogo.56b33243.jpg";